import { Skeleton } from "@/components/Skeleton";
import { cn } from "@/utils/cn";

interface AvatarSkeletonProps {
  /** Size of the avatar (default: 40px) */
  size?: number | string;
  /** Custom className */
  className?: string;
  /** Show label skeleton next to avatar */
  withLabel?: boolean;
  /** Width of label if shown */
  labelWidth?: string | number;
}

/**
 * AvatarSkeleton Component
 * Skeleton for user avatars with optional label
 */
export const AvatarSkeleton = ({
  size = 40,
  className,
  withLabel = false,
  labelWidth = "120px",
}: AvatarSkeletonProps) => {
  if (!withLabel) {
    return (
      <Skeleton
        width={size}
        height={size}
        variant="circular"
        className={cn("flex-shrink-0", className)}
      />
    );
  }

  return (
    <div className={cn("flex items-center gap-3 min-w-0", className)}>
      <Skeleton width={size} height={size} variant="circular" className="flex-shrink-0" />
      <Skeleton width={labelWidth} height="1rem" variant="text" className="flex-shrink-0" />
    </div>
  );
};

AvatarSkeleton.displayName = "AvatarSkeleton";
